



























import Vue from 'vue'
import { FolderServiceProxy,FileServiceProxy,ChangeFileParentDto } from "@/service-proxies/app-v2/dnc.service-proxies";
const folderservice = new FolderServiceProxy();
const fileservice = new FileServiceProxy()
export default Vue.extend ({
  components:{
    // ReleaseFile
  },
  props: {
    visible:{
      type: Boolean,
      default: false,
    },
    ids:{
      type: Array,
      default: () => ({})
    },
    getway:{
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      selectedKey: [], // 选中key
      treeData: [],
      titlelist: [
        {code: 'Release',name: this.$t('page_my_document_publish')},
        {code: 'share',name: this.$t('page_my_document_share')},
        {code: 'copy',name: this.$t('page_my_document_copy')},
        {code: 'move',name: this.$t('page_my_document_move')},
        {code: 'default',name: this.$t('page_my_document_more')},
      ],
      loadedKeys: []
    }
  },
  watch:{
    visible:{
      handler(){
        if(this.visible){
          this.getList('0')
        }
      }
    }
  },
  computed:{
    title(){
      let title = this.$t('page_my_document_more')
      if(this.getway){
        title = this.titlelist.filter(item => item.code === this.getway)[0].name
      }
      return title
    }
  },
  methods: {
    getList(value) {
      this.treeData = []
      this.loadedKeys = []
      this.selectedKey = []
      folderservice.lazyFolderList(value).then(res => {
        if(res){
          const children = this.addsCopedSlots(res)
          this.treeData = [
            {
              title: this.$t('page_my_document'),
              key: '0',
              children: children
            }
          ]
          console.log(this.treeData)
        }
      });
    },
    addsCopedSlots(value){
      value.forEach(element => {
        element.title = element.name
        element.key = element.id
        element.isLeaf = false
      });
      return value
    },
    onSelect(selectedKeys) {
      this.selectedKey = selectedKeys
    },
    onLoadData(treeNode: any) {
      return new Promise(resolve => {
        this.loadedKeys.push(treeNode.dataRef.key)
        folderservice.lazyFolderList(treeNode.dataRef.key).then(res => {
          if(res){
            treeNode.dataRef.children = this.addsCopedSlots(res)
            this.treeData = [...this.treeData];
            resolve();
          }
        });

      });
    },
    handleOk() {
      if(this.selectedKey.length === 0) {
        this.$message.info(`${this.$T('page_my_document_youwant')}${this.title}${this.$t('page_my_document_location')}`)
      }
      const data = new ChangeFileParentDto({
        parentId: this.selectedKey[0],
        sourceIdList: this.ids
      })

      if( this.getway === 'copy' ) {
        fileservice.copy(data).then(res =>{
          this.$message.success(this.$t('page_my_document_copysuccess'))
          this.$emit('close', true)
        })
      } else if( this.getway === 'move' ) {
        fileservice.move(data).then(res =>{
          this.$message.success(this.$t('page_my_document_movesuccess'))
          this.$emit('close', true)
        })
      }
    },
    handleCancel(){
      this.$emit('close', false)
    },
  }
})
